import React, { useState, useContext } from 'react';
import { ConfigContext } from '../../ConfigContextProvider';
import styled from "styled-components";
import { Container, Form, Row, Col } from 'reactstrap';
import Banner from '../../Components/Banner';
import TextField from '../../Components/FormGroup/TextField';
import TextareaField from '../../Components/FormGroup/TextareaField';
import Button from '../../Components/Button';
import { validatePhone, validateEmail } from '../../Components/FormGroup/Validator';
import { useForm, FormProvider, SubmitHandler } from "react-hook-form";
import { ContactType } from '../../Components/Types';
import axios from 'axios';
import { toastConfig } from 'Components/Constants';
import { toast } from 'react-toastify';
import { appInsights } from 'appInsightsAuth';
import { SeverityLevel } from '@microsoft/applicationinsights-web';
import { ContactAPI } from 'API/ContactAPI';

const PageContainer = styled.div`
    padding: 1em;
    display:flex;
    justify-content:center;
    
`;
const ContactForm = styled(Form)`
    width: 60%
`;

function ContactUsPage() {
    const [clientId, apiUrl]: any = useContext(ConfigContext);
    const [disabled, setDisabled] = useState<boolean>(false);
    const methods = useForm<ContactType>();

    const onSubmit: SubmitHandler<ContactType> = async data => {
        if (data.email !== data.confirm_email) {
            const message = "The Email addresses entered do not match";
            toast.error(message, { ...toastConfig, toastId: message + "-toast" });
        }
        else {
            await ContactAPI.post(data);
            const message = "Form has been submitted";
            toast.success(message, { ...toastConfig, toastId: message + "-toast" });
            setDisabled(true);
        }
    }

    return (
        <>
            <Banner mainText="Contact Us" bodyText="Please fill in this form and we'll get back to you" />
            <PageContainer>
                <FormProvider {...methods}>
                    <ContactForm onSubmit={methods.handleSubmit(onSubmit)}>
                        <Row>
                            <Col md={4}>
                                <TextField name="name" label="Name" required={true} />
                            </Col>
                            <Col md={4}>
                                <TextField name="job_title" label="Job Title" required={true} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <TextField name="organisation_name" label="Organisation Name" required={true} />
                            </Col>
                            <Col md={4}>
                                <TextField type="phone" name="tel" label="Tel" maxlength={12} validation={validatePhone} required={true} />
                            </Col>
                        </Row>
                        <Row>
                            <Col md={4}>
                                <TextField name="email" label="Email" type="email" validation={validateEmail} required={true} />
                            </Col>
                            <Col md={4}>
                                <TextField name="confirm_email" label="Confirm Email" type="email" validation={validateEmail} required={true} pasteNotAllowed={true}/>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <TextareaField name="information" label="Any other Information" rows={4} required={true} />
                            </Col>
                        </Row>
                        <Button colour="dark" type="submit" text="submit" disabled={disabled} css={{ marginTop: "1vw", float: "left" }}/>
                    </ContactForm>
                </FormProvider>
            </PageContainer>
        </>
    );
}
export default ContactUsPage;
